var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key},[_c('b-input',{ref:"entry_date",class:_vm.reactiveClass,attrs:{"size":"sm"},on:{"change":_vm.savePoint},model:{value:(_vm.form.entry_date),callback:function ($$v) {_vm.$set(_vm.form, "entry_date", $$v)},expression:"form.entry_date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }